"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardArt = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Image = require("../../../Image/Image");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardArt = exports.CardArt = function CardArt(_ref) {
  var cardArt = _ref.cardArt,
    styles = _ref.styles,
    altText = _ref.altText,
    title = _ref.title,
    className = _ref.className,
    onLoad = _ref.onLoad,
    namespace = _ref.namespace;
  return /*#__PURE__*/_react["default"].createElement(_Image.Image, {
    "data-qe-id": "cardart",
    style: styles,
    src: cardArt,
    alt: altText,
    title: title,
    className: className,
    onLoad: onLoad,
    namespace: namespace
  });
};
CardArt.propTypes = {
  cardArt: _propTypes["default"].string.isRequired,
  styles: _propTypes["default"].object,
  // eslint-disable-line react/forbid-prop-types
  altText: _propTypes["default"].string,
  className: _propTypes["default"].string,
  onLoad: _propTypes["default"].func,
  title: _propTypes["default"].string,
  namespace: _propTypes["default"].string
};
CardArt.defaultProps = {
  styles: {},
  altText: '',
  className: '',
  title: '',
  onLoad: function onLoad() {},
  namespace: 'card-art'
};